import {Footer, ShareTable} from "../../components";

export function SharePage() {
    return (
        <div className="container-fluid mt-5 p-3">
            <ShareTable/>
            <Footer/>
        </div>
    )
}